module.exports = __webpack_public_path__ + "679961b1bcb62327df260260613b0625.jpg";